import * as React from "react";
type Props = {
  className?: string,
};
function SvgLightbulb({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Lightbulb"
      className={className}
    >
      <path
        d="M17.8659 35.6132C17.6365 35.6132 17.4155 35.5911 17.2092 35.5504L17.2043 35.4138C17.2043 37.1878 18.5331 38.6265 20.1708 38.6265C21.7568 38.6265 23.0517 37.2786 23.132 35.583C22.9842 35.6027 22.8304 35.6132 22.6726 35.6132M17.8659 35.6132H22.6726M17.8659 35.6132C16.7407 35.6132 15.8201 35.0818 15.8201 34.4321C15.8201 33.7823 16.7407 33.251 17.8659 33.251H22.6726C23.7978 33.251 24.7185 33.7823 24.7185 34.4321C24.7185 35.0818 23.7978 35.6132 22.6726 35.6132M22.6726 30.7955C23.2194 30.7955 23.7178 30.921 24.0865 31.1265C24.1031 31.1068 24.1124 31.0854 24.1138 31.062C24.2095 29.5182 24.8156 28.5029 26.225 27.515C27.0083 26.9306 28.3163 25.7921 29.2435 23.948C30.6406 21.1653 30.7788 17.5539 29.0787 14.4548C28.7861 13.9225 26.6531 10.1899 22.0547 9.35163C17.3692 8.49826 14.0116 11.3586 13.5494 11.7659C13.1535 12.1154 10.0923 14.8811 10.0923 19.2834C10.0923 21.637 10.8046 25.186 14.5685 27.6949C15.5673 28.3605 16.665 29.4726 16.5107 31.0936C16.8723 30.9083 17.3474 30.7955 17.8659 30.7955M22.6726 30.7955H17.8659M22.6726 30.7955C23.7978 30.7955 24.7185 31.3269 24.7185 31.9766C24.7185 32.6263 23.7978 33.1577 22.6726 33.1577H17.8659C16.7407 33.1577 15.8201 32.6263 15.8201 31.9766C15.8201 31.3269 16.7407 30.7955 17.8659 30.7955M23.3978 14.3148C23.8865 14.6038 24.8729 15.2822 25.6004 16.5805C26.1756 17.6083 26.3421 18.5835 26.3968 19.1507M29.9221 9.88362L33.6876 5.95244M10.1989 9.83327L6.43337 5.24689M19.7708 6.22062V1.00574M33.5435 18.5643H38.9043M1.42859 18.5643H6.7894"
        stroke="currentColor"
        strokeWidth={1}
      />
    </svg>
  );
}
export default SvgLightbulb;
